<pre style="font-family: monospace; font-size: 12px">{{ rule?.resume }}</pre>

